import { useEffect, useMemo, useRef } from 'react';
import { timeoutDuration } from 'utils/constants/dateInfo/time-numbers';
import { debounce } from 'utils/helpers/debounce';
import RidGenerator from 'utils/swarm/rid-generator';

export const useDebouncedCallback = (
  callback: Function,
  delay: number = timeoutDuration.DURATION_300,
  deps: Array<any> = []
) => {
  const ref = useRef<Function>();
  const debounceId = useRef(RidGenerator.rand());

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(debounceId.current, func, delay);
  }, deps);
};
